import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV;
// uat、production 上報錯誤；其餘環境（local/dev/sit）不上報，避免灌入非正式環境的雜訊
const shouldReportErrors = environment === 'production' || environment === 'uat';

if (dsn) {
  Sentry.init({
    dsn,
    environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.2),
    sampleRate: shouldReportErrors ? 1 : 0,
  });
}
